import(/* webpackMode: "eager" */ "/app/src/app/legal/page.tsx");
